export default "__VITE_ASSET__DhPqj3cp__"